export default {
  SET_SHIPPING_ADDRESS_FOR_ITEMS: 'SET_SHIPPING_ADDRESS_FOR_ITEMS',
  SET_SHIPPING_FOR_ITEMS: 'SET_SHIPPING_FOR_ITEMS',
  SET_SHIPPING_PRICE: 'SET_SHIPPING_PRICE',
  UPDATE_SHIPPING: 'UPDATE_SHIPPING',
  IS_SAME_AS_SHIPPING_SENT: 'IS_SAME_AS_SHIPPING_SENT',

  SET_SHIPPING_TYPE: 'SET_SHIPPING_TYPE',
  SET_POINT: 'SET_POINT',
  SET_POINT_DETAIL: 'SET_POINT_DETAIl',
}
